<template>
    <div ref="stackedBarChart" class="stacked-bar-chart"></div>
</template>

<script>
import loadGoogleCharts from "./GoogleChartLoader";
import {getIndicatorKeys, getIndicatorNames} from "./StrataDashboardHelperFunctions";

export default {
    name: "DashboardStackedBarChart",
    data: () => ({
        google: null,
        chart: null,
        column_titles: [],
        timeoutToResize: null
    }),
    props: {
        data: {
            type: Object,
            required: true
        },
        selectedIndicatorName: {
            type: String,
            required: true
        },
    },
    mounted() {
        loadGoogleCharts("current", { packages: ["bar"] }).then((google) => {
            this.google = google;
            this.loadChart();
        });
    },
    methods: {
        loadChart() {
            let height = 500; // default height
            if(this.data.datasets[0].data.features){
                let numFeatures = this.data.datasets[0].data.features.length;
                let chartHeight = numFeatures * 21; // pixel height of bar + padding
                height = chartHeight > height ? chartHeight : height;
            }
            this.chartData = this.google.visualization.arrayToDataTable(this.loadData(this.data))

            this.chartOptions = {
                chart: {
                    title: "Indicators by region",
                },
                bars: "horizontal", // Required for Material Bar Charts.
                hAxis: { format: "decimal" },
                height: height,
                colors: ["#f04638", "#f04638", "#f99e26"],
                isStacked: true,
            };

            new ResizeObserver(this.drawChart).observe(this.$refs.stackedBarChart)
        },
        drawChart() {
            // debounce function
            clearTimeout(this.timeoutToResize);
            this.timeoutToResize = setTimeout(() => {
                console.log("resizing stacked bar")
                var chart = new this.google.charts.Bar(this.$refs.stackedBarChart);
                this.chart = chart;
                chart.draw(this.chartData, this.google.charts.Bar.convertOptions(this.chartOptions));

                this.$emit('stacked-bar-chart', this.chart);
            }, 50)
        },
        loadData(output_data){
            let feature_collection = output_data.datasets[0].data;
            let features = feature_collection.features;
            let indicator_keys = getIndicatorKeys(feature_collection);
            let indicator_names = getIndicatorNames(indicator_keys);
            let column_titles = ["REGION NAME"];
            column_titles = column_titles.concat(indicator_names)
            this.column_titles = column_titles

            let data = []
            data.push(column_titles)
            features.forEach(feature => {
                let featureData = []
                featureData.push(feature.properties.region_name)
                indicator_keys.forEach(indicator_key => {
                    featureData.push(feature.properties[indicator_key])
                })
                data.push(featureData);
            })
            return data;
        }
    },
    watch: {
        selectedIndicatorName(newIndicatorName){
            if(newIndicatorName !== "" || newIndicatorName !== "STRATA SCORE" || this.column_titles.indexOf(newIndicatorName) !== -1){
                let index = this.column_titles.indexOf(newIndicatorName);
                this.chart.setSelection([{row: null, column: index}]);
            } else {
                this.chart.setSelection();
            }
        }
    }
};
</script>